/** Qui a lu les photos. Mathpix n'existe qu'en mathématiques. */
export const LECTEURS_COPIE = ['ia', 'mathpix'];
/**
 * D'où vient la copie : un devoir photographié, un défi de la banque, ou — chantier
 * « manuel vivant », Φ-MV-3 — un EXERCICE du manuel. Un essai d'exercice est une
 * copie comme les autres (AD-MV-11) : même liste, même écran, un seul historique.
 */
export const ORIGINES_COPIE = ['devoir', 'defi', 'exercice'];
/**
 * Les verdicts d'une ligne ou d'une question. `pas_fait` n'est jamais un
 * « faux » : une question sans réponse appelle une aide, pas une sanction.
 */
export const VERDICTS_COPIE = ['juste', 'a_ecrire', 'partiel', 'erreur', 'pas_fait'];
/**
 * Le barème de la note (décision AD-V2-02 du fondateur, 11 septembre) : une
 * question dont seule l'écriture est à revoir est RÉUSSIE ; une question non
 * faite compte zéro et reste dans le total.
 */
export const POINTS_PAR_VERDICT = {
    juste: 1,
    a_ecrire: 1,
    partiel: 0.5,
    erreur: 0,
    pas_fait: 0,
};
/** Photos d'un devoir, au plus (décision du 10 septembre). */
export const MAX_PHOTOS_COPIE = 10;
/** Les témoins d'un devoir photographié : Mathpix sur l'image (maths), Azure « Read » (français). */
export const TEMOINS_PHOTO = ['mathpix', 'azure-read'];
/** Le plus long texte d'une note du tuteur : une phrase. */
export const MAX_CARACTERES_NOTE_TUTEUR = 280;
/** Au plus, par essai : au-delà, c'est une séance qu'il faut. */
export const MAX_NOTES_PAR_TRAVAIL = 10;
//# sourceMappingURL=copie.js.map